<template>
  <div class="mt-4">
    <v-row class="my-0">
      <v-col
        cols="12"
        class="py-0"
      >
        <v-card class="py-2 px-4 mb-1 base-card d-flex justify-end align-center shadow">
          <v-tabs
            class="elevation-0 overflow-auto"
            v-model="tab"
            height="35"
            hide-slider
            center-active
            show-arrows
            background-color="transparent"
            @change="resetFilters"
          >
            <template v-for="(tab, i) in tabs">
              <v-tab
                v-if="tab.visible"
                class="mx-2 black--text"
                active-class="primary--text"
                :key="i"
                :to="tab.to"
              >
                <span class="btn-text">{{ tab.text }}</span>
              </v-tab>
            </template>
          </v-tabs>
          <v-btn
            outlined
            small
            color="primary"
            class="action-btn elevation-0 rounded-lg"
            height="32"
            @click="dialog = true"
          >
            <v-icon class="uikit-icon plus primary size-20" />
            <span class="btn-text">Добавить научную работу</span>
          </v-btn>
          <v-btn
            class="ml-1 pl-0"
            title="Поиск"
            icon
            @click="showSearch"
          >
            <v-icon class="uikit-icon search" />
          </v-btn>
          <v-btn
            icon
            class="ml-1"
            title="Фильтр"
            @click="showFilter"
          >
            <v-icon class="uikit-icon filter size-20" />
          </v-btn>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="mb-0"
      :class="isShowFilter || isShowSearch ? 'mt-3' : 'mt-0'"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <CommonWorkFilters
          :page-name="pageName"
          :show-search="isShowSearch"
          :show-filter="isShowFilter"
          :showFilterFields="showFilterFields"
          :excludeTypes="excludeTypes"
          @setFilters="setFilters"
          @removeChips="setTableHeight"
          @multipleFilterChangeHeight="setTableHeight"
        />
      </v-col>
    </v-row>

    <router-view
      :triggerSetTableHeight="triggerSetTableHeight"
      :filtersProp="filters"
      @setShowFilterFields="setShowFilterFields"
      @setExcludeTypes="setExcludeTypes"
    />

    <CommonWorkCreationDialog
      :dialog="dialog"
      :isShowMode="isShowMode"
      @createCommonWork="createCommonWork"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeCommonWork"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import CommonWorkFilters from '@/components/Works/CommonWorkParent/CommonWorkFilters'
import CommonWorkCreationDialog from '@/components/commonWork/dialogs/CommonWorkCreation.vue'
import ConfirmDialog from '@/components/dialogs/Confirm'
import { Filters } from '@/models'
import { cloneDeep, debounce } from 'lodash'
import { getWorkTypeNameById } from '@/scripts'
import { commonWorkApi } from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'CommonWork',

  metaInfo: {
    title: 'Научные работы'
  },

  components: {
    CommonWorkCreationDialog,
    ConfirmDialog,
    CommonWorkFilters
  },

  data() {
    return {
      filters: new Filters(),
      isShowFilter: false,
      isShowSearch: false,

      triggerSetTableHeight: false,

      tab: null,

      showFilterFields: {
        isShowSearchString: true,
        isShowWorkTypeId: true,
        isShowStatusId: true,
        isShowYearId: true,
        isShowDepartmentList: false,
        isShowFIO: false
      },

      excludeTypes: [],

      selectedItem: null,
      confirmDialog: false,
      isShowMode: false,
      removeLoading: false,
      dialog: false
    }
  },

  computed: {
    ...mapGetters('user', ['isAdmin', 'isSomeModerator']),

    tabs() {
      return [
        { text: 'Данные о добавленных работах', to: '/works/commonWork/allWorks', pageName: 'allWorks', visible: true },
        {
          text: 'Научные работы на рассмотрение',
          to: '/works/commonWork/review',
          pageName: 'review',
          visible: this.isAdmin || this.isSomeModerator
        },
        {
          text: 'Отклоненные работы',
          to: '/works/commonWork/decline',
          pageName: 'decline',
          visible: this.isAdmin || this.isSomeModerator
        }
      ]
    },

    pageName() {
      return this.tabs.find(el => el.to === this.tab)?.pageName
    }
  },

  methods: {
    resetFilters: function () {
      this.filters = new Filters()
    },

    showSearch() {
      this.isShowSearch = !this.isShowSearch
      this.isShowFilter = false
      this.setTableHeight()
    },

    showFilter() {
      this.isShowFilter = !this.isShowFilter
      this.isShowSearch = false
      this.setTableHeight()
    },

    setTableHeight() {
      this.triggerSetTableHeight = !this.triggerSetTableHeight
    },

    setShowFilterFields(showFilterFields) {
      this.showFilterFields = cloneDeep(showFilterFields)
    },

    setExcludeTypes(excludeTypesContent) {
      this.excludeTypes = cloneDeep(excludeTypesContent)
    },

    async createCommonWork(workType) {
      await this.$router.push('/works/' + getWorkTypeNameById(workType.id) + '/edit/' + 0)
      this.closeDialog()
    },

    async removeCommonWork() {
      try {
        this.removeLoading = true
        await commonWorkApi.remove(this.selectedItem.id)

        const index = this.list.findIndex(el => el.id === this.selectedItem.id)
        this.commonWorkParent.splice(index, 1)

        this.$toast.info('Работа успешно удалена')
        this.closeConfirmDialog()
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка удаления работы')
      } finally {
        this.removeLoading = false
      }
    },

    setFilters: debounce(async function (filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    }
  }
}
</script>

<style scoped></style>
